import { api } from './client';
import { ApiKey, ApiKeyCreated, ApiKeyListResponse } from '../types';

export const apiKeysApi = {
  /**
   * Create a new personal API key. The response is the only time the
   * full key is available — show it to the user immediately.
   */
  createKey: async (label: string): Promise<ApiKeyCreated> => {
    return api.post<ApiKeyCreated>('/v1/api-keys/', { label });
  },

  /**
   * List the user's active API keys (prefix only, no secret material)
   */
  listKeys: async (): Promise<ApiKey[]> => {
    const response = await api.get<ApiKeyListResponse>('/v1/api-keys/');
    return response.items;
  },

  /**
   * Revoke an API key. Revoked keys stop authenticating immediately.
   */
  revokeKey: async (keyId: string): Promise<void> => {
    return api.delete<void>(`/v1/api-keys/${keyId}`);
  },
};

export default apiKeysApi;
